<template>
  <div class="layout">
    <v-logo component="div" class="layout__logo" />

    <div class="content">
      <router-view />
    </div>

    <footer class="footer">
      © {{ years }} AYSA OÜ
    </footer>
  </div>
</template>

<script>
import VLogo from '@/components/VLogo.vue';

export default {
  components: {
    VLogo,
  },
  computed: {
    years() {
      const from = this.BRAND_CONFIG.fromYear;
      const to = new Date().getFullYear();
      if (from) {
        return `${from}-${to}`;
      }
      return to;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  max-width: 500px;
  flex-grow: 1;
  width: 100%;
  margin: 0 auto;
  padding: 15px 10px;

  &__logo {
    width: fit-content;
    margin: 0 auto;
  }
}

.content {
  padding: 25px 0;
}

.footer {
  margin-top: auto;
  text-align: center;
  font-weight: 500;
}
</style>
